import { HttpClinet } from './../utils/config'

export const typeAPI = {
    getType: () => {
        return HttpClinet({
            url: `/type/getType`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    getTypeAdmin: () => {
        return HttpClinet({
            url: `/type/getTypeAdmin`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    DownloadFile: (data) => {
        return HttpClinet({
            url: `/type/DownloadFile`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
            data: data
        })
            .then((response) => {
                return response
            })
            .catch((error) => {
                throw error
            })
    },
    updateStatus: (data) => {
        return HttpClinet({
            url: `/type/updateStatus`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    createType: (data) => {
        return HttpClinet({
            url: `/type/createType`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    editType: (data) => {
        return HttpClinet({
            url: `/type/editType`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    getTypeByID: (_id) => {
        return HttpClinet({
            url: `/type/getTypeByID/${_id}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    DeleteFile: (data) => {
        return HttpClinet({
            url: `/type/DeleteFile`,
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    addFolderInType: (data) => {
        return HttpClinet({
            url: `/type/addFolderInType`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    addFileInType: (data) => {
        return HttpClinet({
            url: `/type/addFileInType`,
            method: 'POST',
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
}